import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaymentTermsComponent } from './payment-terms.component';
import { TranslateModule } from '@ngx-translate/core';
import { AmountFormatModule, StaticMsgModule } from '@lib/pipes';

@NgModule({
  declarations: [PaymentTermsComponent],
  imports: [CommonModule, TranslateModule, AmountFormatModule, StaticMsgModule],
  exports: [PaymentTermsComponent],
})
export class PaymentTermsModule {}
